import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PageHeader from "../Components/PageHeader";

const UserSignUpDetail = () => {
	const [file, setFile] = useState(null);

	const handleFileChange = (event) => {
		setFile(event.target.files[0]);
	};

	const handleCancelClick = () => {
		setFile(null);
	};

	return (
		<>
			<Header />
			<PageHeader pagename="SignUpp" />
			<section className="signup">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Upload your Medical Report{" "}
								</h2>
								<form>
									<Link
										className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										to="/"
									>
										<span className="bg-wrapper w-100">
											{" "}
											<i className="fa-solid fa-upload"></i>{" "}
											<span className="ps-2"> Upload Report </span>
										</span>
									</Link>
									<h4 className=" level-7 text-center mt-3 mb-3 primary-regular-font text-decoration-none extra-color-1">
										You can attach more than one file{" "}
									</h4>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group d-flex-wrapper-upload col-lg-12 d-flex align-items-center">
													<div
														className="pdf-icon"
														onClick={() =>
															document.getElementById("file-input").click()
														}
													>
														<i className="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={handleFileChange}
														className="form-control"
														id="file-input"
														style={{ display: "none" }}
													/>
													<div
														className="icon-input"
														onClick={handleCancelClick}
													>
														<i className="fa-solid fa-xmark"></i>
													</div>
													<span class="medical-placeholder ml-2">
														{file ? file.name : "Medical report.pdf"}
													</span>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<Link
								className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
								to="/personal-info"
							>
								<span className="bg-wrapper w-100">Submit </span>
							</Link>
							<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
								<Link
									to="/personal-info"
									className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
								>
									Skip
								</Link>
							</h4>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserSignUpDetail;
